(function(){
  if(window.__dzHomeInit) return; window.__dzHomeInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(){
    var els = document.querySelectorAll('.dz-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window) || reduce){ els.forEach(function(e){e.classList.add('is-in')}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target);} });
    },{threshold:.12, rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){ io.observe(e); });
  }

  function initStagger(){
    document.querySelectorAll('[data-dz-stagger]').forEach(function(wrap){
      var step = parseInt(wrap.getAttribute('data-dz-stagger'),10)||90;
      Array.prototype.forEach.call(wrap.children,function(c,i){ c.style.setProperty('--dz-d',(i*step)+'ms'); });
    });
  }

  function initHero(){
    document.querySelectorAll('[data-dz-hero]').forEach(function(hero){
      if(hero.__dz) return; hero.__dz = true;
      var slides = hero.querySelectorAll('.dz-hero__slide');
      var dots = hero.querySelectorAll('.dz-hero__dot');
      if(slides.length < 2) return;
      var i = 0, timer, delay = parseInt(hero.getAttribute('data-dz-hero'),10)||6000;
      function go(n){
        slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active');
      }
      function start(){ if(reduce) return; stop(); timer = setInterval(function(){ go(i+1); }, delay); }
      function stop(){ clearInterval(timer); }
      dots.forEach(function(d,idx){ d.addEventListener('click',function(){ go(idx); start(); }); });
      var p = hero.querySelector('[data-dz-prev]'), n = hero.querySelector('[data-dz-next]');
      p && p.addEventListener('click',function(){ go(i-1); start(); });
      n && n.addEventListener('click',function(){ go(i+1); start(); });
      hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', start);
      start();
    });
  }

  /* Carousels: arrows anywhere in the same section; drag only after real movement so card links stay clickable */
  function initSliders(){
    document.querySelectorAll('[data-dz-slider]').forEach(function(s){
      if(s.__dz) return; s.__dz = true;
      var track = s.querySelector('.dz-slider__track');
      if(!track) return;
      var scope = s.closest('section, footer, .shopify-section') || s;
      var prev = scope.querySelector('[data-dz-prev]'), next = scope.querySelector('[data-dz-next]');
      function step(){ var c = track.firstElementChild; if(!c) return 320; var g = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 20; return c.getBoundingClientRect().width + g; }
      function atEnd(){ return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
      function atStart(){ return track.scrollLeft <= 4; }
      prev && prev.addEventListener('click',function(e){ e.preventDefault(); if(atStart()){ track.scrollTo({left:track.scrollWidth,behavior:'smooth'}); } else { track.scrollBy({left:-step(),behavior:'smooth'}); } });
      next && next.addEventListener('click',function(e){ e.preventDefault(); if(atEnd()){ track.scrollTo({left:0,behavior:'smooth'}); } else { track.scrollBy({left:step(),behavior:'smooth'}); } });

      var down=false, moved=false, sx=0, sl=0;
      track.addEventListener('mousedown',function(e){ if(e.button!==0) return; down=true; moved=false; sx=e.pageX; sl=track.scrollLeft; });
      window.addEventListener('mouseup',function(){ if(!down) return; down=false; setTimeout(function(){ track.classList.remove('is-drag'); }, 0); });
      track.addEventListener('mousemove',function(e){
        if(!down) return;
        var dx = e.pageX - sx;
        if(!moved && Math.abs(dx) < 6) return;
        moved = true; track.classList.add('is-drag');
        e.preventDefault(); track.scrollLeft = sl - dx;
      });
      /* swallow the click only if the user actually dragged */
      track.addEventListener('click',function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } }, true);

      var auto = parseInt(s.getAttribute('data-dz-slider'),10);
      if(auto && !reduce){
        var t = setInterval(function(){ if(atEnd()){ track.scrollTo({left:0,behavior:'smooth'}); } else { track.scrollBy({left:step(),behavior:'smooth'}); } }, auto);
        scope.addEventListener('mouseenter',function(){ clearInterval(t); });
      }
    });
  }

  function initFaq(){
    document.querySelectorAll('[data-dz-faq] details').forEach(function(d){
      if(d.__dz) return; d.__dz = true;
      d.addEventListener('toggle',function(){
        if(d.open){ d.parentElement.querySelectorAll('details[open]').forEach(function(o){ if(o!==d) o.open=false; }); }
      });
    });
  }

  function initQuickAdd(){
    document.querySelectorAll('[data-dz-quick-add]').forEach(function(form){
      if(form.__dz) return; form.__dz = true;
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var btn = form.querySelector('button');
        btn.disabled = true; btn.innerHTML = 'Adding…';
        var fd = new FormData(form);
        fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
          .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function(){ btn.innerHTML = 'Added ✓'; document.dispatchEvent(new CustomEvent('cart:update')); setTimeout(function(){ window.location.href = '/cart'; }, 500); })
          .catch(function(){ btn.innerHTML = 'Try again'; btn.disabled = false; });
      });
    });
  }

  function initCount(){
    var els = document.querySelectorAll('[data-dz-count]');
    if(!els.length) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting) return; io.unobserve(en.target);
        var el = en.target, end = parseFloat(el.getAttribute('data-dz-count')), suffix = el.getAttribute('data-dz-suffix')||'', dur = 1400, t0 = null;
        if(reduce){ el.textContent = end + suffix; return; }
        function tick(ts){ if(!t0) t0 = ts; var p = Math.min((ts-t0)/dur,1); var e = 1 - Math.pow(1-p,3); el.textContent = Math.round(end*e) + suffix; if(p<1) requestAnimationFrame(tick); }
        requestAnimationFrame(tick);
      });
    },{threshold:.5});
    els.forEach(function(e){ io.observe(e); });
  }

  function init(){ initStagger(); initReveal(); initHero(); initSliders(); initFaq(); initQuickAdd(); initCount(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function(){ setTimeout(init, 50); });
})();
